/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import styled from "@emotion/styled";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  Dialog,
  Slide,
  Typography,
  IconButton,
  requirePropFactory,
} from "@mui/material";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useRecoilValue } from "recoil";
import { configState, loginState } from "../lib/Store";
import pr from "../lib/pr";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import io from "socket.io-client";
import moment from "moment";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import CloseIcon from "@mui/icons-material/Close";
import queryString from "query-string";
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { ReactComponent as ClearIcon } from '../svg/clear.svg';

const debug = false;

const MyTableCell = styled(TableCell)`
  font-size: 12px;
`;

const Container = styled.div`
  .rootContainer {
    background: url(/img/hr_bg.jpg?v=2019-10-08) no-repeat;
    height: 100vh;
    background-size: cover;
    display: flex;
    flex-direction: column;
  }
  .bg {
    border: 2px solid green;
  }

  .br {
    border: 2px solid red;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .yellow {
    color: #fffb3b;
  }

  .bg-red {
    background: #df0011;
  }

  .bg-yellow {
    background: #cd9d24;
  }
  .bg-green {
    background: #007a5b;
  }

  .bg-blue {
    background: #006ab6;
  }

  .bg-gray {
    background: #666666;
  }

  .hrContainer {
    flex: 1;
  }

  .zoneContainer {
    display: flex;
  }

  .zoneContainer .item {
    height: 60px;
    width: 20%;
    color: white;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Orbitron", sans-serif;
  }

  .bandContainer {
    margin-left: 15px;
  }

  .bandContent {
    float: left;
    width: 430px;
    height: 210px;
    border: 1px solid #000000;
    margin-right: 5px;
    margin-bottom: 5px;
    overflow: hidden;
  }  

  /* large */
  .bandContainer.large .bandContent{
    width: 350px;
  }

  .bandContent .faceData {
    position: absolute;
    z-index: 200;
    padding-top: 10px;
    padding-left: 10px;
  }

  /* large */
  .bandContainer.large .faceData{
    padding-top: 5px;
    padding-left: 5px;
  }  

  .bandContent .nameData {
    position: absolute;
    z-index: 100;
    color: white;
    font-size: 50px;
    text-align: right;
    width: 420px;
  }

  /* large */
  .bandContainer.large .nameData{
    font-size: 42px;
    width: 340px;
  }    

  .bandContent .nameBG {
    position: absolute;
    width: 430px;
    height: 60px;
    background-color: #000000;
    opacity: 0.1;
  }

  /* large */
  .bandContainer.large .nameBG{
    width: 350px;
  }

  .bandContent .heartData {
    position: absolute;
    text-align: right;
    width: 425px;
    margin-top: 60px;
    color: white;
    font-size: 36px;
    font-family: "Orbitron";
  }

  /* large */
  .bandContainer.large .heartData{
    width: 350px;
  }     

  .bandContent .heartMax {
    position: absolute;
    width: 425px;
    text-align: right;
    font-family: "Orbitron";
    color: white;
    font-size: 55px;
    margin-top: 95px;
  }

  /* large */
  .bandContainer.large .heartMax{
    width: 350px;
    font-size: 46px;
  }      

  .minute {
    font-family: "Orbitron";
    position: absolute;
    color: white;
    margin-top: 105px;
    margin-left: 10px;
    font-size: 23px;
  }

  .bandContainer.large .minute {
    margin-top: 147px;
    font-size: 21px;
  }

  .kcal {
    font-family: "Orbitron";
    position: absolute;
    color: white;
    margin-top: 128px;
    margin-left: 10px;
    font-size: 23px;
  }

  .bandContainer.large .kcal {
    margin-top: 170px;
    font-size: 21px;
  }

  .bandContent .faceFrame {
    width: 100px;
    height: 100px;
    overflow: hidden;
  }

  .bandContent .faceFrame img {
    width: 90px;
    height: 90px;
  }

  .bandContent .rate .R {
    font-family: "Orbitron";
    float: right;
    color: white;
    font-size: 58px;
    padding-right: 10px;
  }

  .logoWrap {
    display: flex;
    align-items: center;
  }
  .logoWrap .fullscreen {
    margin-left: 30px;
    padding: 5px 10px;
  } 

  /* large */
  .win_animation {
    width: 430px;
    height: 200px;    
  }
  .bandContainer.large .win_animation {    
    width: 350px;
  }  

  .bandContainer.large .run_man  {
    display: none;
  }  
  
  .bandContainer.large .progress_bar  {
    display: none;
  }  
  
`;

let load_bands = localStorage.getItem("bands");
load_bands = JSON.parse(load_bands);
let bands = load_bands !== null ? load_bands : [];

let socket;

function HrEvent() {
  const login = useRecoilValue(loginState);

  // test
  // const config = {
  //   api: 'http://192.168.76.23:3001'
  // }

  // production
  const config = {
    api: 'https://api.docircuit.org:3001'
  }

  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const [logged, setlogged] = useState(false);
  const [devices, setDevices] = useState([]);
  const { ccid, kiosk_id } = queryString.parse(window.location.search);
  const [cid, setCid] = useState(""); // 두써킷 센터코드 (빈값은 심박전용 센터)

  // 키오스크 로그인
  useEffect(() => {
    axios
      .post(config.api + "/hr/kiosk_login", { ccid: ccid, kiosk_id: kiosk_id })
      .then((res) => {
        if (res.data.success === 1) {
          setLoaded(true);
          if (res.data.cid !== "") {
            setCid(res.data.cid);
          }
        } else {
          window.location.href = "/";
        }
      })
      .catch((e) => {
        alert(e);
      });
  }, []);

  // 풀스크린
  const toggle_full_screen = () => {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  };

  // SOCKET
  useEffect(() => {
    socket = io.connect("http://localhost:9125", {
      cors: {
        origin: "*",
        withCredentials: true,
      },
    });
    socket.on("connect", function () {
      console.log("socket - connected!");
    });
    socket.on("disconnect", function () {
      console.log("socket - diconnected!");
    });
    socket.on("data", function (data) {
      handleBand(data);
    });
  }, []);

  // ==================================================== //
  // 칼로리 계산 - 1 (1초에 한번)
  // ==================================================== //
  useEffect(() => {
    const timer = setInterval(() => {
      timer_sum_cal();
    }, 1000);
  }, []);

  // =========================================== //
  // 칼로리 계산 - 2 (1초에 한번)
  // =========================================== //
  function timer_sum_cal() {
    let zone_point = 0;
    for (let i = 0; i < bands.length; i++) {
      var HR = bands[i].heart_beat;
      var W = bands[i].weight;
      var A = bands[i].age;
      var T = 1 / 60 / 60;
      var cal =
        ((-55.0969 + 0.6309 * HR + 0.1988 * W + 0.2017 * A) / 4.184) * 30 * T;
      bands[i].kcal = bands[i].kcal + cal;

      // TEST : 특정 밴드만 100% 만들기
      // if(bands[i].device_id === '582695') {
      //   bands[i].zone2+=50;
      // }

      // 구간별 머문시간(초)
      bands[i].sec++;
      if (bands[i].heart_zone === 1) {
        bands[i].zone1++;
      }
      if (bands[i].heart_zone === 2) {
        bands[i].zone2++;
      }
      if (bands[i].heart_zone === 3) {
        bands[i].zone3++;
      }
      if (bands[i].heart_zone === 4) {
        bands[i].zone4++;
      }
      if (bands[i].heart_zone === 5) {
        bands[i].zone5++;
      }

      // 구간 포인트 합산
      // 16.21.30.35 === 너무힘듬
      // 12.15.18.25 === 힘듬
      // 18.15.12.10 ?
      // zone_point =
      //   parseInt(bands[i].zone1) * 0 +
      //   parseInt(bands[i].zone2 / 18) +
      //   parseInt(bands[i].zone3 / 15) +
      //   parseInt(bands[i].zone4 / 12) +
      //   parseInt(bands[i].zone5 / 10);

      // 5분 이벤트 (3초 1포인트 = 300초 100포인트)
      // 4-5구간 3.3분
      zone_point =
        parseInt(bands[i].zone1) * 0 +
        parseInt(bands[i].zone2 / 3) +
        parseInt(bands[i].zone3 / 3) +
        parseInt(bands[i].zone4 / 2) +
        parseInt(bands[i].zone5 / 2);        

      if (zone_point > 100) zone_point = 100;
      bands[i].zone_point = zone_point;
    }
  }

  // ==================================================== //
  // 밴드정리 - 1
  // ==================================================== //
  useEffect(() => {
    const timer = setInterval(() => {
      clear_bands();
    }, 1000 * 30); // 30초마다
  }, []);

  // ==================================================== //
  // 밴드정리 - 2 // x초 이상 데이타가 없는 밴드 정리
  // ==================================================== //
  function clear_bands() {
    // console.log("clear_bands");
    const clear_time = 60 * 5; // 5min   

    // for (let i = 0; i < bands.length; i++) {
    //   frequency = bands[i].frequency;
    //   if (frequency > clear_time) {
    //     bands = bands.filter((item) => bands[i].device_id !== item.device_id);
    //     break;
    //   }
    // }

    // 밴드정리
    bands = bands.filter((item) => item.frequency < clear_time);
  }

  // ==================================================== //
  // 새로고침용 싱크
  // ==================================================== //
  useEffect(() => {
    const timer = setInterval(() => {
      store_state();
    }, 3000);
  }, []);
  const store_state = () => {
    localStorage.setItem("bands", JSON.stringify(bands));
  };

  // ==================================================== //
  // 회원정보 연동 (1)
  // ==================================================== //
  useEffect(() => {
    const timer = setInterval(() => {
      post_sync();
    }, 6000);
  }, []);

  // =========================================== //
  // 회원정보 연동 (2)
  // =========================================== //
  const post_sync = async () => {
    // console.log("post_sync");
    let result = await axios.post(config.api + "/hr/band_active", {
      ccid: ccid,
    });
    let active_band = result.data.rows;

    // 비회원 업데이트
    let idx;
    for (let i = 0; i < bands.length; i++) {
      if (bands[i].mcd === '') {
        idx = active_band.findIndex(
          (el) => el.device_id === bands[i].device_id
        );
        // console.log( bands[i].device_id + ':'+idx);
        if (idx > -1) {
          bands[i].mb_name = active_band[idx].mb_name;
          bands[i].mcd = active_band[idx].mcd;
          bands[i].age = active_band[idx].age;
          bands[i].weight = active_band[idx].weight;
          bands[i].sex = active_band[idx].sex;
          bands[i].avatar = active_band[idx].avatar;
          bands[i].kpoint = active_band[idx].kpoint;
        }
      }
    }
  };

  // ==================================================== //
  // 밴드출력 - 1
  // ==================================================== //
  useEffect(() => {
    const timer = setInterval(() => {
      draw_bands();
    }, 1000 / 3); // 심박 숫자 화면 업데이트
  }, []);

  // ==================================================== //
  // 밴드출력 - 2
  // ==================================================== //
  function draw_bands() {
    // console.log("draw_bands");
    var time = moment(new Date()); //todays date

    // 칼로리 역순 + 밴드번호 역순
    bands = bands.sort((a, b) => {
      var k1 = a.kcal;
      var k2 = b.kcal;
      var d1 = a.device_id;
      var d2 = b.device_id;
      if (k2 - k1 === 0) {
        return d2 - d1;
      } else {
        return k2 - k1;
      }
    });

    let device_id;
    let mb_name;
    let regtime;
    let frequency_obj, frequency, seconds;
    for (let i = 0; i < bands.length; i++) {
      device_id = bands[i].device_id;
      mb_name = bands[i].mb_name;
      frequency_obj = moment.duration(time.diff(bands[i].time));
      frequency = frequency_obj.asSeconds();
      bands[i].frequency = frequency; // 마지막 수신 후 지난시간(초)
      // console.log(frequency);
    }
    setDevices((state) => [...bands]); // 화면 업데이트
  }

  // =========================================== //
  // 심박데이타 화면 업데이트
  // =========================================== //
  function update_heart(idx, heart_beat, time) {

    // 심박구간 임의 지정 (화면 캡쳐용)
    // if(bands[idx].device_id === '582695') {
    //   heart_beat = 123;  
    // }
    // if(bands[idx].device_id === '582769') {
    //   heart_beat = 136;  
    // }    
    // if(bands[idx].device_id === '582776') {
    //   heart_beat = 148;  
    // }    
    // if(bands[idx].device_id === '582695') {
    //   heart_beat = 180;  
    // }    

    // 최대심박 계산
    var age = bands[idx].age;
    var heart_max = 220 - age;
    var heart_max_rate = parseInt((100 * heart_beat) / heart_max);
    var heart_zone = 1;
    var bg_color = "bg-gray";

    // 심박구간 계산
    if (heart_max_rate >= 60 && heart_max_rate < 70) {
      bg_color = "bg-blue";
      heart_zone = 2;
    }
    if (heart_max_rate >= 70 && heart_max_rate < 80) {
      bg_color = "bg-green";
      heart_zone = 3;
    }
    if (heart_max_rate >= 80 && heart_max_rate < 90) {
      bg_color = "bg-yellow";
      heart_zone = 4;
    }
    if (heart_max_rate >= 90) {
      bg_color = "bg-red";
      heart_zone = 5;
    }

    bands[idx].heart_beat = heart_beat;
    bands[idx].time = time;
    bands[idx].heart_max = heart_max;
    bands[idx].heart_max_rate = heart_max_rate;
    bands[idx].heart_zone = heart_zone;
    bands[idx].bg_color = bg_color;


  }

  // ==================================================== //
  // 전송된 데이타 처리 (socket)
  // ==================================================== //
  const handleBand = async (data) => {
    //console.log("handleBand");
    let { device_id, heart_beat, time } = data;
    device_id = device_id + "";

    // 밴드 추가
    let idx = bands.findIndex((e) => e.device_id === device_id);
    let target = bands.filter((e) => e.device_id === device_id);

    // console.log('idx=',idx);
    // console.log('count=',target.length);

    if (idx === -1 && target.length === 0) {
      console.log("new band!");

      // 밴드매핑 2022.09
      let result = await axios.post(config.api + "/hr/get_center_band", {
        ccid: ccid
      });
      let idx1 = result.data.rows.findIndex(el => el.serial === device_id);
      let band_no = '';
      if (idx1 > -1) {
        band_no = result.data.rows[idx1].band_no;
      }

      const data = {
        ccid: ccid,
        sec: 0,
        zone1: 0,
        zone2: 0,
        zone3: 0,
        zone4: 0,
        zone5: 0,
        device_id: device_id,
        heart_beat: heart_beat,
        regtime: time,
        time: time,
        mb_name: "",
        kcal: 0, // 누적칼로리
        age: 40,
        weight: 60,
        heart_max: 0, // 최대심박수
        heart_max_rate: 0, // 최대심박수 %
        avatar: "/avatar_img/no_mb.png", // 얼굴
        heart_zone: 1, // 심박구간 1/2/3/4/5
        bg_color: "bg-gray",
        run: 1, // 달리는 아이콘
        frequency: 0, // 심박수간 간격
        zone_point: 0, // 구간포인트 합계
        sex: "남",
        mcd: "",
        heart_point: 0, // 심박포인트 적립용
        band_no: band_no,
        kcal_shot: 0, // 칼로리샷
        kpoint: 0, // 칼로리포인트 (루틴)
      };
      bands.push(data);

      // axios post new band
      post_band_new(data);
    } else {
      update_heart(idx, heart_beat, time);
    }
  };

  // =========================================== //
  // 밴드 DB전송
  // =========================================== //
  const post_band_new = async (data) => {
    let result = await axios.post(config.api + "/hr/band_add", data);
  };

  const onClose = () => {
    window.location.href = "/home";
  };

  // =========================================== //
  // 심박포인트 적립 (100점 달성) : 1일 1회만 지급함
  // =========================================== //
  const onSavePoint = async () => {
    let result;

    const filter = bands.filter(
      (el) => el.mcd !== "" && el.zone_point >= 100 && el.heart_point === 0
    ); // 100포인트 완료후 미적립한 데이타
    for (let i = 0; i < filter.length; i++) {
      filter[i].heart_point = 100; // 100포인트 지급 (화면처리)
      await axios.post(config.api + "/hr/save_heart_point", {
        // 포인트지급 (DB)
        cid: cid,
        hmcd: filter[i].mcd,
        point: 100,
      });

      // 푸시알림
      await axios.post(config.api + '/push/to_hmcd', {
        cid: cid,
        hmcd: filter[i].mcd,
        title: '심박',
        message: '심박포인트 100포인트가 적립되었습니다.',
      });

    }
  };
  useEffect(() => {
    if (cid !== "") {
      setInterval(() => {
        onSavePoint();
      }, 1000 * 3);
    }
  }, [cid]);
  // const onSavePointTest = async() => {
  //   bands[1].heart_point=0;
  //   console.table(bands[1].heart_point);
  //   // TEST
  //   // await axios.post(config.api+"/hr/save_heart_point", { // 포인트지급 (DB)
  //   //   cid:'CID00000009',
  //   //   hmcd:'12',
  //   //   point:100
  //   // });
  //   // return;
  // }

  // ==================================================== //
  // 칼로리 스넵샷 (루프) / 정해신 시간마다 칼로리 변화량 서버로 전달
  // ==================================================== //
  useEffect(() => {
    if (cid !== '') {
      setInterval(() => { // 10초마다 칼로리 정보 스넵샷

        console.log('snapshot');
        let kcal = 0;
        let kcal_shot = 0;
        let amount = 0;
        let members = []; // 전달할 데이타  
        let mcd = '';
        let frequency = 0;
        for (let i = 0; i < bands.length; i++) {
          kcal = parseInt(bands[i].kcal);
          kcal_shot = parseInt(bands[i].kcal_shot);
          frequency = parseInt(bands[i].frequency);

          mcd = bands[i].mcd;
          if (kcal > kcal_shot && frequency < 30) { // 신호간격 30초 이하 포인트 지급
            amount = kcal - kcal_shot;
            bands[i].kcal_shot = kcal;
            if (kcal_shot === 0) { // 최초 연결되기 전 데이타 제외
            } else {              
              if (mcd !== '') {
                members.push({
                  mcd: mcd,
                  add: amount,
                  kcal: kcal_shot,
                  kcal_shot: kcal_shot
                });
              }
            }
          }
          else {
            console.log(bands[i].band_no,'nothing');
          }
        }

        // post
        if (members.length > 0) {
          console.log('칼로리 전송');
          console.table(members);
          axios.post(config.api + '/hr/kcal_add', {
            cid: cid,
            members: members
          })
            .catch((e) => {
              console.log(e);
            });
        }

      }, 1000 * 60 * 1); // 1분 마다 칼로리 전송
    }
  }, [cid]);

  // 밴드 초기화
  const resetClick = () => {
    bands = [];
  }

  return (
    <>
      {!loaded ? (
        <Loading></Loading>
      ) : (
        <Container>
          <HelmetProvider>
            <Helmet>
              <link
                rel="stylesheet"
                type="text/css"
                href="https://fonts.googleapis.com/css?family=Audiowide|Michroma|Orbitron|Russo+One"
              />
            </Helmet>
          </HelmetProvider>
          {/* <button onClick={onSavePointTest}>포인트주기</button> */}

          {/* 디버그 */}
          {debug &&
            <Box position="absolute" backgroundColor="white" m={2} bottom={60} fontSize={12} zIndex={999}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <MyTableCell>cid</MyTableCell>
                      <MyTableCell>밴드번호</MyTableCell>
                      <MyTableCell>시리얼</MyTableCell>
                      <MyTableCell>최대심박</MyTableCell>
                      <MyTableCell>심박수</MyTableCell>
                      <MyTableCell>포인트전송</MyTableCell>
                      <MyTableCell>심박포인트</MyTableCell>
                      <MyTableCell>mcd</MyTableCell>
                      <MyTableCell>z1</MyTableCell>
                      <MyTableCell>z2</MyTableCell>
                      <MyTableCell>z3</MyTableCell>
                      <MyTableCell>z4</MyTableCell>
                      <MyTableCell>칼로리</MyTableCell>
                      <MyTableCell>칼로리샷</MyTableCell>
                      <MyTableCell>칼로리포인트</MyTableCell>
                      <MyTableCell>프리퀀시</MyTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      bands.map((item, index) => {
                        return <TableRow key={index} >
                          <MyTableCell>{cid}</MyTableCell>
                          <MyTableCell>{item.band_no}</MyTableCell>
                          <MyTableCell>{item.device_id}</MyTableCell>
                          <MyTableCell>{item.heart_max_rate}%</MyTableCell>
                          <MyTableCell>{item.heart_beat}</MyTableCell>
                          <MyTableCell>{item.heart_point}</MyTableCell>
                          <MyTableCell>{item.zone_point}</MyTableCell>
                          <MyTableCell>{item.mcd}</MyTableCell>
                          <MyTableCell>{item.zone1}</MyTableCell>
                          <MyTableCell>{item.zone2}</MyTableCell>
                          <MyTableCell>{item.zone3}</MyTableCell>
                          <MyTableCell>{item.zone4}</MyTableCell>
                          <MyTableCell>{parseInt(item.kcal)} kcal</MyTableCell>
                          <MyTableCell>{item.kcal_shot} kcal</MyTableCell>
                          <MyTableCell>{item.kpoint} pt</MyTableCell>
                          <MyTableCell>{parseInt(item.frequency)}</MyTableCell>
                        </TableRow>
                      })
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>}

          <div className="rootContainer">

            <div className="hrContainer">
              <div className="logoWrap">
                <div style={{ marginLeft: 10 }}>
                  <img src="/img/logo-landscape.png?v=99" width="150" />
                </div>
                <div>
                  <IconButton
                    css={css`
                      margin-left: 30px;
                      background: white;
                      border: 2px solid black;
                    `}
                    onClick={toggle_full_screen}
                  >
                    <ZoomOutMapIcon />
                  </IconButton>
                </div>
                <div css={css`margin-left: 5px;`}>
                  <ClearIcon width="40" height="40" fill="black" onClick={resetClick}/>
                </div>                
                {/* <div>
                  <IconButton
                    css={css`
                      margin-left: 5px;
                      background: white;
                      border: 2px solid black;
                    `}
                    onClick={onClose}
                  >
                    <CloseIcon />
                  </IconButton>
                </div> */}
              </div>
              <div
                css={css`
                  height: 10px;
                `}
              ></div>

              {/* 밴드 수량별 디자인 다르게 적용하기 :*/}
              <div className={devices.length > 16 ? "bandContainer large" : "bandContainer"}>
                {/* <div>{devices.length}</div> */}
                {devices.map((item, index) => {
                  if (index > 19) return; // 최대 밴드 수

                  let bg_color = item.bg_color;
                  let min = (item.sec / 60).toFixed(0);
                  let width = (430 / 100) * item.zone_point + "px"; // 진행 바
                  let left = (380 / 100) * item.zone_point + "px"; // 사람위치
                  if (cid === '') left = 0;
                  let kpoint = 0;
                  if (item.mcd !== '') {
                    kpoint = item.kpoint + parseInt(item.kcal); // 칼로리 포인트             
                  }


                  return (
                    <div className={"bandContent " + bg_color} key={index}>
                      <div className="faceData">
                        <div className="faceFrame">
                          <img src={item.avatar} />
                        </div>
                      </div>
                      <div className="nameData">
                        {item.mb_name} {item.mb_name === '' ? item.device_id : null} - {item.band_no}
                      </div>
                      <div className="nameBG"></div>
                      <div className="heartData">

                        <span>
                          <img
                            className="icon_heart"
                            src="/img/heart_img.png"
                            width="20"
                          />
                        </span>
                        <span
                          css={css`
                            margin-left: 5px;
                            padding-right: 10px;
                          `}
                        >
                          {item.heart_beat}
                        </span>

                        {cid !== "" && ( // 직영점만 포인트 나옴
                          <>
                            <span>
                              <img
                                className="icon_point"
                                src="/img/icon_p.png"
                                width="23"
                              />
                            </span>
                            <span
                              css={css`
                                margin-left: 5px;
                                padding-right: 10px;
                              `}
                            >
                              {item.zone_point}
                            </span>
                          </>
                        )}


                      </div>

                      <div className="heartMax">
                        <span>{item.heart_max_rate}</span>
                        <span
                          css={css`
                            padding-right: 10px;
                          `}
                        >
                          %
                        </span>
                      </div>

                      <div className="kcal">
                        <span>
                          <img src="/img/history.png" width="16"></img>
                        </span>
                        <span
                          css={css`
                            margin-left: 4px;
                          `}
                        >
                          {min}
                        </span>
                        <span
                          css={css`
                            margin-left: 3px;
                          `}
                        >
                          min
                        </span>
                      </div>

                      <div className="minute">
                        <span>
                          <img src="/img/cal.png" width="16"></img>
                        </span>
                        <span
                          css={css`
                            margin-left: 5px;
                          `}
                        >
                          {parseInt(item.kcal)}
                        </span>
                        <span
                          css={css`
                            margin-left: 3px;
                          `}
                        >
                          kcal
                        </span>
                      </div>

                      { /* 사람 */}
                      <Box sx={{ position: "absolute", marginTop: 20, marginLeft: left }}>
                        {cid !== "" && item.zone_point < 99 && (
                          <Box className="run_man">
                            <img
                              src={`/run/run${item.heart_zone === 1 ? 2 : item.heart_zone
                                }.gif`}
                              width="50"
                            ></img>
                          </Box>
                        )}
                        {cid === "" &&
                          <Box className="run_man">
                            <img
                              src={`/run/run${item.heart_zone === 1 ? 2 : item.heart_zone
                                }.gif`}
                              width="50"
                            ></img>
                          </Box>
                        }

                      </Box>

                      { /* 도착한 사람 */}
                      {cid !== "" && item.zone_point > 99 &&
                        <Box className="run_man" sx={{ position: "absolute", marginTop: 19.5, marginLeft: left }}>
                          <img src="/run/win.gif" width="48"></img>
                        </Box>}

                      { /* 진행바 */}
                      {cid !== "" &&
                        <Box
                          className="progress_bar"
                          sx={{
                            position: "absolute",
                            backgroundColor: "gray",
                            width: width,
                            height: 3,
                            marginTop: 25.8,
                          }}
                        ></Box>
                      }

                      {/* 축하아이콘 */}
                      {cid !== "" && item.zone_point > 99 && (
                        <Box sx={{ position: "absolute" }}>
                          <img className="win_animation"
                            src="/run/bomb.gif"
                          ></img>
                        </Box>
                      )}
                    </div>
                  );
                })}
                <Box sx={{ clear: "both" }}></Box>
              </div>
            </div>
            <Box className="zoneContainer">
              <div className="item bg-gray"> 50% - 60%</div>
              <div className="item bg-blue"> 60% - 70%</div>
              <div className="item bg-green">70% - 80%</div>
              <div className="item bg-yellow">80% - 90%</div>
              <div className="item bg-red">90% - 100%</div>
            </Box>
          </div>
        </Container>
      )}
    </>
  );
}

export default HrEvent;
